var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-6"},[_c('UiTable',{attrs:{"data":_vm.content.data.rows,"config":_vm.tableConfig,"is-loading":_vm.generalLoader,"fixed-header":"","max-height":"520px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }